import packageJson from '../../../../package.json';

export class DbBaseModel {
    epochTime: string;
    createdDate: string;
    appVersion: string;

    constructor() {
        this.epochTime = new Date().getTime().toString();
        this.createdDate = new Date().toString();
        this.appVersion = packageJson.version;
    }
}
